import type { OrderStatus } from '~entities/order';

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  NEW: 'New',
  IN_PROGRESS: 'In progress',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
  CANCELLED: 'Cancelled',
  FINISHED: 'Finished',
};

export const ORDER_STATUS_OPTIONS = (
  Object.keys(ORDER_STATUS_LABELS) as OrderStatus[]
).map((value) => ({ value, label: ORDER_STATUS_LABELS[value] }));

export const isOrderStatus = (value: string): value is OrderStatus =>
  value in ORDER_STATUS_LABELS;
